import { render, staticRenderFns } from "./ExchangeBalance.vue?vue&type=template&id=63ba9376&scoped=true"
import script from "./ExchangeBalance.vue?vue&type=script&lang=js"
export * from "./ExchangeBalance.vue?vue&type=script&lang=js"
import style0 from "./ExchangeBalance.vue?vue&type=style&index=0&id=63ba9376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba9376",
  null
  
)

export default component.exports